import React from "react";

export function Logo({ className = "", size = 36 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
      data-testid="brand-logo"
    >
      <rect width="64" height="64" rx="12" fill="#1C352D" />
      <path d="M32 10 L52 32 L32 54 L12 32 Z" fill="none" stroke="#D4AF37" strokeWidth="2" />
      <path d="M32 10 L32 54" stroke="#D4AF37" strokeWidth="1.2" />
      <path d="M12 32 L52 32" stroke="#D4AF37" strokeWidth="1.2" />
      <path d="M32 18 L44 32 L32 46 L20 32 Z" fill="#D4AF37" fillOpacity="0.15" stroke="#D4AF37" strokeWidth="1.4" />
      <circle cx="32" cy="32" r="3" fill="#D4AF37" />
    </svg>
  );
}

export function Wordmark({ className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand-wordmark">
      <Logo size={32} />
      <div className="flex flex-col leading-none">
        <span className="font-serif text-[17px] tracking-tight text-[#1C352D]">Ecominerali</span>
        <span className="text-[9px] font-mono uppercase tracking-[0.28em] text-[#C59B27]">Milano · 2019</span>
      </div>
    </div>
  );
}
